import React, { useEffect, useState } from 'react';
import './PwaInstallPrompt.css';
import { ihm_viewer__dictionary, locale } from '../../../Application/i18n/i18nViewer';

const PwaInstallPrompt = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstallable, setIsInstallable] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            window.__pwaDeferredPrompt = e;
            setIsInstallable(true);
        };

        if (window.__pwaDeferredPrompt) {
            setDeferredPrompt(window.__pwaDeferredPrompt);
            setIsInstallable(true);
        }

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        const handleAppInstalled = () => {
            setIsInstallable(false);
            setDeferredPrompt(null);
            window.__pwaDeferredPrompt = null;
        };

        window.addEventListener('appinstalled', handleAppInstalled);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', handleAppInstalled);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;

        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;

        if (outcome === 'accepted') {
            setIsInstallable(false);
        }

        setDeferredPrompt(null);
    };

    if (!isInstallable) {
        return null;
    }

    return (
        <div className="pwa-install-wrapper" onClick={handleInstallClick} title={ihm_viewer__dictionary.PWA_INSTALL_TOOLTIP[locale()]}>
            <svg width="20" height="20" viewBox="3 1 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z" />
            </svg>
        </div>
    );
};

export default PwaInstallPrompt;
